import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = ['signUpPageShown', 'signUp'] as const;

export const signUpEvents = getMappedEvents([...EVENTS]);
